var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntroLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 443,
    height: 404,
    viewBox: "0 0 443 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440.769 381.845L234.803 8.81695C231.565 3.39108 227.031 1.35671 221.85 0.678481V0C216.668 0 211.486 2.71301 208.247 8.13888L2.28158 381.167C-2.25227 388.628 0.338187 398.123 6.81511 402.192C13.9397 406.94 22.3599 400.836 22.3599 400.836L32.7228 394.054L67.0508 371.672L94.9011 352.003L207.6 147.177C210.838 141.751 215.372 139.716 220.554 139.038C225.735 139.038 230.917 141.751 234.155 147.177L346.854 352.003L374.705 371.672L409.032 394.054L419.396 400.836C419.396 400.836 427.815 406.261 434.94 402.192C442.712 398.123 445.303 388.627 440.769 381.845Z",
    fill: "#161616"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroLogo);
export default __webpack_public_path__ + "static/media/introLogo.74158464.svg";
export { ForwardRef as ReactComponent };